<template>
    <div class="regions">

        <!-- [ Header ] start -->
        <!--<Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />-->
        <!-- [ Header ] end -->

        <div class="content">
            <!-- [ Menu ] start -->
            <!--<Menu :open="open" @setCompany="GetRegions" @companyName="companyName"/>-->
            <!-- [ Menu ] end -->

            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <el-button @click="openModal" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Region</el-button>
                        <el-button @click="openModalEditRegion" :disabled="disabledBtn" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit">Edit Region</el-button>
                        <el-button @click="deleteRegion" :disabled="disabledBtn" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-delete">Delete Region</el-button>
                    </div>

                    <ag-grid-vue style="width: 100%; height: 90%;" class="ag-theme-balham" id="myGrid"
                                 :gridOptions="gridOptions"
                                 @grid-ready="onGridReady"
                                 :columnDefs="columnDefs"
                                 :defaultColDef="defaultColDef"
                                 :rowDragManaged="true"
                                 :animateRows="true"
                                 :rowData="rowData"
                                 :rowSelection="rowSelection"
                                 @selection-changed="onSelectionChanged">
                    </ag-grid-vue>

                </div>
            </div>
        </div>


        <!-- [ Modal add region] start -->
        <sweet-modal ref="region" class="modal">
            <h1 v-if="addRegionToggle">Add Region</h1>
            <h1 v-else>Edit Region</h1>
            <el-form :model="form" status-icon ref="form" label-width="0" class="demo-ruleForm">
                <el-form-item>
                    <el-input v-if="addRegionToggle" placeholder="Name" v-model="form.name"></el-input>
                    <el-input v-else placeholder="Name" v-model="formGet.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-if="addRegionToggle" placeholder="Code" v-model="form.code"></el-input>
                    <el-input v-else placeholder="Code" v-model="formGet.code"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="addRegionToggle" @click="addRegion('form')" class="modal__btn" type="primary" plain size="small">Add</el-button>
                    <el-button v-else @click="editRegion('formGet')" class="modal__btn" type="primary" plain size="small">Edit Region</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!-- [ Modal add region] start -->

        <!-- [ Modal are you sure] start -->
        <sweet-modal ref="confirmation" title="Delete region">
            Are you sure you want to delete this region?
            <template slot="box-action">
                <a class="button" @click="deleteConfirm">Ok</a> &nbsp;
                <a class="button" @click="$refs.confirmation.close()">Cancel</a>
            </template>
        </sweet-modal>
        <!-- [ Modal are you sure] end -->

        <!-- [ success modal] end -->
        <sweet-modal ref="success" icon="success">
            Save successfully
        </sweet-modal>
        <!-- [ success modal] end -->
    </div>
</template>

<script>
    // import Header from '@/components/Header.vue'
    // import Menu from '@/components/Menu.vue'
    import axios from 'axios'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import {AgGridVue} from "ag-grid-vue"


    export default {
        name: 'my-regions',
        components: {
            // Header,
            // Menu,
            AgGridVue,
            SweetModal,

        },
        beforeCreate() {

        },
        beforeMount() {
            this.gridOptions = {};
            this.columnDefs = [
                { field: "id", },
                { field: "name" },
                { field: "code" }
            ];
            this.defaultColDef = {
                resizable: true,
                width: 150,
                sortable: true,
                filter: true
            };
            this.rowSelection = "single";
        },
        mounted(){
            this.GetRegions();
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
            this.gridApi.sizeColumnsToFit();
            // this.gridApi.sizeColumnsToFit();
        },
        data() {
            return {
                companyNameSelect: '',
                open: false,

                addRegionToggle: true,
                rowData: null,
                companyId: '',
                form: {
                    name: '',
                    code: ''
                },
                formGet: {
                    name: '',
                    code: ''
                },
                // Tree
                gridOptions: null,
                gridApi: null,
                // Info
                disabledBtn: true,
                info: {
                    id: '',
                    name: '',
                    code: ''
                },
            }
        },
        methods: {
            refreshBlock(){

            },
            // showMenu() {
            //     this.open = true
            //     console.log('---', this.open);
            // },
            // hideMenu() {
            //     this.open = false
            //     console.log('---', this.open);
            // },
            // companyName(name) {
            //     this.companyNameSelect = name
            // },
            GetRegions(){
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                    .post(`/api/v1/projectRegions/list?companyId=${this.$route.query.companyId}`)
                    .then(response => {
                        loader.hide()
                        console.log('---', response.data);
                        console.log(this.$route.query.companyId)
                        this.rowData = response.data.list
                    })
                    .catch(error => {
                      loader.hide()
                      // this.notification("Notification", error.response.data.message, "info")
                        // if (error.response.data.statusCode == 401) {
                        //     localStorage.clear();
                        //     this.$router.push('/login')
                        // }
                        console.log('An error occurred:', error);
                    });
            },
            openModal() {
                this.addRegionToggle = true
                console.log('---', 'add');
                this.$refs.region.open();
            },
            addRegion(){
                console.log('add Region')
                let data = {
                    companyId: this.$route.query.companyId,
                    name: this.form.name,
                    code: this.form.code
                }
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post("/api/v1/projectRegions/create?", data)
                    .then(response => {
                    console.log('---', response.data);
                    if (response.data.success){
                        this.GetRegions();
                        this.$refs.success.open();
                        setTimeout(() => {
                            this.$refs.success.close();
                        }, 1000);
                        this.form.name = '';
                        this.form.code = '';
                        this.$refs.region.close();
                        this.disabledBtn = true;
                    }
                    })
                    .catch(error => {
                      this.notification("Notification", error.response.data.message, "info")
                        // if (error.response.data.statusCode == 401) {
                        //     localStorage.clear()
                        //     this.$router.push('/login')
                        // }
                        console.log('An error occurred:', error);
                    });
            },
            openModalEditRegion(){
                let selectedRows = this.gridApi.getSelectedRows();
                console.log("Edit Region")
                this.addRegionToggle = false
                console.log(selectedRows[0].id)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectRegions/item?companyId=${this.$route.query.companyId}&projectRegionId=${selectedRows[0].id}`)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("success");
                            this.formGet.name = response.data.item.name;
                            this.formGet.code = response.data.item.code;
                            this.$refs.region.open();
                        }
                    })
                    .catch(error => {
                      this.notification("Notification", error.response.data.message, "info")
                        // if (error.response.data.statusCode == 401) {
                        //     localStorage.clear()
                        //     this.$router.push('/login')
                        // }
                        console.log('An error occurred:', error);
                    });
            },
            editRegion(){
                let selectedRows = this.gridApi.getSelectedRows();
                let data = {
                    name: this.formGet.name,
                    code: this.formGet.code
                }
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectRegions/update?companyId=${this.$route.query.companyId}&projectRegionId=${selectedRows[0].id}`, data)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            this.GetRegions();
                            this.$refs.success.open();
                            setTimeout(() => {
                                this.$refs.success.close();
                            }, 1000);
                            this.formGet.name = '';
                            this.formGet.code = '';
                            this.$refs.region.close();
                            this.disabledBtn = true;
                        }
                    })
                    .catch(error => {
                      this.notification("Notification", error.response.data.message, "info")
                        // if (error.response.data.statusCode == 401) {
                        //     localStorage.clear()
                        //     this.$router.push('/login')
                        // }
                        console.log('An error occurred:', error);
                    });
            },
          notification(title, message, type) {
            this.$notify({
              title: title,
              message: message,
              type: type
            });
          },
            deleteRegion(){
                // this.$refs.confirmation.open();

                this.$confirm('This will permanently delete the regions. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'info'
                }).then(() => {
                    this.$message({
                    type: 'success',
                    message: 'Delete completed'
                    });

                    let selectedRows = this.gridApi.getSelectedRows();
                    console.log(selectedRows[0].id)
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios.post(`/api/v1/projectRegions/delete?companyId=${this.$route.query.companyId}&projectRegionId=${selectedRows[0].id}`)
                        .then(response => {
                            console.log('---', response.data);
                            if (response.data.success){
                                console.log("success");
                                this.$refs.success.open();
                                setTimeout(() => {
                                    this.$refs.success.close();
                                }, 1000);
                                this.$refs.confirmation.close();
                                this.GetRegions();
                                this.disabledBtn = true;
                            }
                        })
                        .catch(error => {
                            console.log('An error occurred:', error);
                        });
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                    });
                });
            },
            deleteConfirm(){
                let selectedRows = this.gridApi.getSelectedRows();
                console.log(selectedRows[0].id)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectRegions/delete?companyId=${this.$route.query.companyId}&projectRegionId=${selectedRows[0].id}`)
                    .then(response => {
                        console.log('---', response.data);
                        if (response.data.success){
                            console.log("success");
                            this.$refs.success.open();
                            setTimeout(() => {
                                this.$refs.success.close();
                            }, 1000);
                            this.$refs.confirmation.close();
                            this.GetRegions();
                            this.disabledBtn = true;
                        }
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            onGridReady(params) {},
            onSelectionChanged() {
                var selectedRows = this.gridApi.getSelectedRows();
                this.info.id = selectedRows[0].id;
                this.info.name = selectedRows[0].name;
                this.info.code = selectedRows[0].code;
                this.disabledBtn = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
.regions{
    background: #f2f4f7;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__tree {
    width: 100%;
    padding: 0 0 10px 0;
  }
//   &__info {
//     display: flex;
//     flex-direction: column;
//     width: 65%;
//     padding: 0 0 10px 10px;
//   }
  &__info-tab {
    height: 50%;
    overflow-y: auto;
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        margin-bottom: 8px;
        // span {
        //   font-weight: 500;
        //   color: #909399;
        // }
      }
    }
  }
  &__person {
    height: 50%;
  }
}
// [ Wrapper ] end

// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end
</style>
